import { createContext, useContext } from 'react';

// Everything the v2 screens share: the signed-in user, the month's model,
// the API client, the legacy helpers from App.js (tipe lists, P&L and plan
// loader screens), and the open-sheet / toast helpers.
export const V2 = createContext(null);
export const useV2 = () => useContext(V2);
